/**
 * Friendly page names for analytics. Keys are lowercase paths because the
 * router matches case-insensitively (`/Ticket` and `/ticket` are both used).
 */
const PAGE_NAMES: Record<string, string> = {
  '/': 'Welcome',
  '/gameselection': 'Game Selection',
  '/gokart': 'Go-Kart Promo',
  '/checkout': 'Checkout',
  '/userdetails': 'User Details',
  '/cartandpayment': 'Cart & Payment',
  '/paystackpaymentpage': 'Paystack Payment',
  '/ticket': 'Ticket (Payment Success)',
  '/queue': 'Queue Display',
};

/** Routes that are internal displays rather than customer-facing pages. */
const NON_CUSTOMER_PATHS = ['/queue'];

const normalize = (pathname: string) => {
  const lower = pathname.toLowerCase();
  return lower.length > 1 && lower.endsWith('/') ? lower.slice(0, -1) : lower;
};

export const getPageName = (pathname: string): string =>
  PAGE_NAMES[normalize(pathname)] || pathname;

export const isCustomerFacingPath = (pathname: string): boolean =>
  NON_CUSTOMER_PATHS.indexOf(normalize(pathname)) === -1;
